import { render, staticRenderFns } from "./AttributeForm.vue?vue&type=template&id=d368eb28&scoped=true"
import script from "./AttributeForm.vue?vue&type=script&lang=js"
export * from "./AttributeForm.vue?vue&type=script&lang=js"
import style0 from "./AttributeForm.vue?vue&type=style&index=0&id=d368eb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d368eb28",
  null
  
)

export default component.exports